import React from "react";

import DromoUploaderDropBox from "../Common/DromoUploaderDropBox";
import getDromoOnboardingPropertyFields from "./OnboardingPropertyDromoFields";

const OnboardingPropertyDromoUploader = ({ resultsHandler, dropboxInnerContent }) => {
  return (
    <DromoUploaderDropBox
      fields={getDromoOnboardingPropertyFields()}
      importIdentifier="Onboarding Customer Properties"
      resultsHandler={resultsHandler}
      dropboxInnerContent={dropboxInnerContent}
    />
  );
};

export default OnboardingPropertyDromoUploader;
